<template>
  <div class="mt-4 bg-gray-200 rounded border p-4">
    <p>Please confirm.</p>
    <div class="mt-2 grid grid-flow-col justify-start gap-2 items-baseline">
      <BaseButton small primary :disabled="destroying" @click="destroy"> Delete </BaseButton>
      <BaseButton small ghost :disabled="destroying" @click="cancel"> Cancel </BaseButton>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    note: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      destroying: false,
      errorMsg: '',
    };
  },

  methods: {
    setDestroying(value) {
      this.destroying = value;
      this.$emit('destroying', value);
    },
    async destroy() {
      if (this.destroying) return;

      this.setDestroying(true);

      try {
        const result = await this.$store.dispatch({
          type: 'ui/notes/destroy',
          id: this.note.id,
        });

        this.$emit('destroyed', result);
      } catch (error) {
        /** silence */
      } finally {
        this.setDestroying(false);
      }
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
